import PersonIcon from '@material-ui/icons/Person';
import DescriptionIcon from '@material-ui/icons/Description';
import Description from "../Pages/ETL-S3Configuration/Description";
import FileUpload from "../Pages/ETL-S3Configuration/FileUpload";
import FileDownload from "../Pages/ETL-S3Configuration/FileDownload";
import ReportsDashboard from "../Pages/ETL-S3Configuration/ReportsDashboard";
import IngestionDashboard from "../Pages/ETL-S3Configuration/IngestionDashboard";
import config from "../assets/constants/slug.config.json";


const dynamicRoutes = JSON.parse(localStorage.getItem('dashboardJSON'));
const etlDashboardRoutes = [
  {
    name: "Catalogue",
    icon: DescriptionIcon,
    layout: "/etl",
    path: '',
    module: "DataRepository",
    permissionSlug: config.data_repo_catalogue,
    subRoutes: [
      {
        path: "/reports",
        name: "Reports",
        icon: PersonIcon,
        component: 'ReportsDashboard',
        layout: "/etl",
        permissionSlug: 'reports_datarepo_5'
      },
      {
        path: "/ingestion",
        name: "Ingestion Analytics",
        icon: PersonIcon,
        component: 'IngestionDashboard',
        layout: "/etl",
        permissionSlug: 'data_repo_ingestion_dashboard_4'
      }
    ]
  },
]

// Dynamically generate routes from JSON
etlDashboardRoutes.forEach(route => {
  const newSubRoutes = Array.isArray(dynamicRoutes)
    ? dynamicRoutes.filter(subRoute => subRoute.module === 'data_repository')
    .map(subRoute => ({
      path: subRoute.path,
      name: subRoute.name,
      icon: subRoute.icon === "PersonIcon" ? PersonIcon : DescriptionIcon, 
      component: subRoute.component, 
      layout: subRoute.layout,
      permissionSlug: subRoute.permissionSlug,
      parameter_store_name: subRoute.parameter_store_name || '',
      lob: subRoute.lob || '',
      embedConsole: subRoute.embedConsole || false,
      role: subRoute.role || '',
    })) : [];

  route.subRoutes = [...route.subRoutes, ...newSubRoutes];

});

export default etlDashboardRoutes;